export const HOME_PATH = "/";
